import { IonSpinner } from '@ionic/react'
import { useStore } from 'effector-react'
import { UseFormReturn } from 'react-hook-form'
import { RecognitionStatusEnum } from '~/shared/api'
import { myPalette } from '~/shared/ui/theme'
import { $recognizedDocuments } from '../recognizedModel'
import { PendingDescription, PendingWrapper } from './styled'
import { Form } from './ui/Form'
import { FormValues } from './ui/Form/model'

type AdditionalDataProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
  disabledChangePhone?: boolean
}

export function AdditionalDataStep({
  onSuccess,
  form,
  disabledChangePhone,
}: AdditionalDataProps) {
  const recognizedDocuments = useStore($recognizedDocuments)
  const recognizedDocumentsPending = Object.values(
    recognizedDocuments || {},
  ).some((document) => document.status === RecognitionStatusEnum.pending)

  return (
    <Form
      onSuccess={onSuccess}
      form={form}
      disabledChangePhone={disabledChangePhone}
      disabled={recognizedDocumentsPending}
      extraBlock={
        recognizedDocumentsPending ? (
          <PendingWrapper>
            <IonSpinner
              style={{ width: '60px', color: myPalette.coral.main }}
            ></IonSpinner>
            <PendingDescription>
              Для того что бы продолжить дальше, дождитесь распознавания
              документов
            </PendingDescription>
          </PendingWrapper>
        ) : null
      }
    />
  )
}
